import React from "react";
import styles from "./basicbutton.module.css";
import {Button} from "semantic-ui-react";
import DesktopContainer from "../../../container/DesktopContainer";
import MobileTabletContainer from "../../../container/MobileTabletContainer";

const DefaultBasicButton = ({link, children}) => (
    <>
        <MobileTabletContainer className={styles.mobile}>
            <Button as={'a'} href={link} className={styles.defaultBtn}>{children}</Button>
        </MobileTabletContainer>
        <DesktopContainer className={styles.desktop}>
            <Button as={'a'} href={link} className={styles.defaultBtn}>{children}</Button>
        </DesktopContainer>
    </>

);


export default DefaultBasicButton;